import ForgottenPasswordContainer from "../../features/auth/components/ForgottenPasswordForm";

const ForgottenPassword = () => {
  return <ForgottenPasswordContainer />;
};

export default ForgottenPassword;
